import { gql } from '@apollo/client';
/**
 * @fragment DealHeaderFragment
 * @since 1.0.0
 */
export const DealHeaderFragment = gql `
  fragment DealHeaderFragment on Deal {
    id
    status
    stage

    user {
      fullname
      image {
        url
      }
    }

    partner {
      name
    }
  }
`;
